import { GetterTree } from "vuex";
import { RootState } from "@/store/types";

import { SelfieState } from "../types";

const getters: GetterTree<SelfieState, RootState> = {
  getTurnDirection: (state) => state.turnDirection,
};
export default getters;
